import HomePage from '../pages/home.vue';

// Others
import NotFoundPage from '../pages/404.vue';

// Reporting
import Cockpit from '../pages/reporting/cockpit.vue';

// VEGSYST
import Selection from '../pages/pageSelection/selection.vue';
import ViewProject from '../pages/viewProject/pageViewProject.vue';
import RegisterProject from '../pages/registerProject/pageRegisterProject.vue';
import PageTwoRegisterProject from '../pages/registerProject/pageTwoRegisterProject.vue';
import PageProjects from '../pages/openProject/openProject.vue';
import PageDataBase from '../pages/dataBase/dataBase.vue';
import PageClimate from '../pages/climate/climateGreenHouse/climate.vue';
import PageFloor from '../pages/ground/ground.vue';
import PageCrop from '../pages/crop/crop.vue';
import PageFertilizers from '../pages/fertilizers/fertilizers.vue';
import PageIrrigation from '../pages/irrigation/irrigation.vue';
import PageManure from '../pages/manure/manure.vue';
import PageResultGreenHouse from '../pages/result/tabs-result-greenhouse.vue';
import PageResultOpenAir from '../pages/result/resultOpenAir/pageResultOpenAir.vue';
import PageResult from '../pages/result/result.vue';
import PageResultGreenHouseManure from '../pages/result/resultGreenHouse/manureResult/manurePage.vue';
import PageIrrigationResult from '../pages/result/resultGreenHouse/irrigationResult/irrigationResult.vue';
import PageInfoIrrigation from
  '../pages/result/resultGreenHouse/irrigationResult/infoIrrigation/infoIrrigationPage.vue';
import PageDetailInformation from
  '../pages/result/resultGreenHouse/irrigationResult/infoIrrigation/infoIrrigationPage.vue';
import PageDetailManure from '../pages/result/resultGreenHouse/manureResult/detailsManure/detailsManurePage.vue';
import ExtractionNutrWeek from '../components/manureResult/tabExtractionsNutr/index.vue';
import RecommendationWeek from '../components/manureResult/recomendationWeek/index.vue';
import Seasonal from '../components/manureResult/seasonalOverview/index.vue';
import GroundNutritionReport from '../components/manureResult/groundNutritionReport/index.vue';
import ClimateResult from '../pages/result/resultOpenAir/climateResult.vue';
import CropResult from '../pages/result/resultOpenAir/cropResult.vue';
import FloorResult from '../pages/result/resultOpenAir/floorResult.vue';
import TabWaterContentDrainageLeaching from '../components/result/resultOpenAir/TabWaterContentDrainageLeaching.vue';
import TabNMineralized from '../components/result/resultOpenAir/TabNMineralized.vue';
import IrrigationResultEx from '../pages/result/resultOpenAir/irrigationResult.vue';
import ContributionNResult from '../pages/result/resultOpenAir/contributionNResult.vue';
import RecommendationsResult from '../pages/result/resultOpenAir/recommendationsResult.vue';

const routes = [
  // Default
  {
    path: '/',
    component: Cockpit,
  },
  // Reporting
  {
    path: '/cockpit/',
    component: Cockpit,
  },
  {
    path: '/home/',
    component: HomePage,
  },
  // VEGSYST
  {
    path: '/selection/',
    component: Selection,
  },
  {
    path: '/pageViewProject/',
    component: ViewProject,
  },
  {
    path: '/pageRegisterProject/',
    component: RegisterProject,
  },
  {
    path: '/pageTwoRegisterProject/',
    component: PageTwoRegisterProject,
  },
  {
    path: '/openProject/',
    component: PageProjects,
  },
  {
    path: '/climateResult/',
    component: ClimateResult,
  },
  {
    path: '/cropResult/',
    component: CropResult,
  },
  {
    path: '/floorResult/',
    component: FloorResult,
    tabs: [
      {
        path: '/WATER-CONTENT-DRAINAGE-LEACHING/',
        id: 'WATER-CONTENT-DRAINAGE-LEACHING',
        component: TabWaterContentDrainageLeaching,
      },
      {
        path: '/N-MINERALIZED/',
        id: 'N-MINERALIZED',
        component: TabNMineralized,
      },
    ],
  },
  {
    path: '/irrigationResultEx/',
    component: IrrigationResultEx,
  },
  {
    path: '/contributionNResult/',
    component: ContributionNResult,
  },
  {
    path: '/recommendationsResult/',
    component: RecommendationsResult,
  },
  {
    path: '/dataBase/',
    component: PageDataBase,
  },
  {
    path: '/climate/',
    component: PageClimate,
  },
  {
    path: '/floor/',
    component: PageFloor,
  },
  {
    path: '/crop/',
    component: PageCrop,
  },
  {
    path: '/fertilizers/',
    component: PageFertilizers,
  },
  {
    path: '/irrigation/',
    component: PageIrrigation,
  },
  {
    path: '/manure/',
    component: PageManure,
  },
  {
    path: '/tabs-result-greenhouse/',
    component: PageResultGreenHouse,
  },
  {
    path: '/tabs-result/',
    component: PageResult,
  },
  {
    path: '/manureResult/',
    component: PageResultGreenHouseManure,
  },
  {
    path: '/manureResult/detailManure',
    component: PageResultGreenHouseManure,
  },
  {
    path: '/irrigationResult/',
    component: PageIrrigationResult,
  },
  {
    path: '/infoIrrigation/',
    component: PageInfoIrrigation,
  },
  {
    path: '/detailInformation/',
    component: PageDetailInformation,
  },
  {
    path: '/detailManure/',
    component: PageDetailManure,
    tabs: [
      {
        path: '/extract/',
        id: 'tab-extract',
        component: ExtractionNutrWeek,
      },
      {
        path: '/nutGround/',
        id: 'tab-nutGround',
        component: GroundNutritionReport,
      },
      {
        path: '/recommendation/',
        id: 'tab-recommendation',
        component: RecommendationWeek,
      },
      {
        path: '/seasonal/',
        id: 'tab-seasonal',
        component: Seasonal,
      },
    ],
  },
  {
    path: '/pageResultOpenAir/',
    component: PageResultOpenAir,
  },
  // No found
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;
